export enum RecipientRequestType {
  PreviousRun = 1,
  Preview = 2,
}
